import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Lineage from "./Lineage/Lineage";
import PlainEnglish from "./PlainEnglish/PlainEnglish";
import RawData from "./RawData/RawData";
import DeepViewTabsLoader from "./DeepViewTabsLoader";
import { useSelector } from "react-redux";
import { selectDeepViewLoading } from "../../features/deepViewSlice";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface Props {
  columnKey?: string;
  /** Label of the column the user clicked, e.g. "Total Income (USD)" */
  columnLabel?: string;
}

const DatacollectionLastRunTabs = ({ columnKey, columnLabel }: Props) => {
  const [value, setValue] = React.useState(0);
  const isLoading = useSelector(selectDeepViewLoading);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{
              "& .MuiTab-root": {
                color: "#00000099",

                "&.Mui-selected": {
                  color: "#9C27B0",
                },
              },

              /* Active line color */
              "& .MuiTabs-indicator": {
                backgroundColor: "#9C27B0",
                height: "3px", // optional
                borderRadius: "10px", // optional
              },

              "& .MuiTabs-flexContainer": {
                justifyContent: "flex-start",
              },

              "& .MuiTab-root:first-of-type": {
                paddingLeft: 1.5,
              },
            }}
          >
            <Tab disableRipple label="Plain English" {...a11yProps(0)} />
            <Tab disableRipple label="Lineage" {...a11yProps(1)} />
            <Tab
              disableRipple
              label="Raw data (Coming soon)"
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>
        {isLoading ? (
          <DeepViewTabsLoader />
        ) : (
          <>
            <CustomTabPanel value={value} index={0}>
              <PlainEnglish columnKey={columnKey} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Lineage columnKey={columnKey} columnLabel={columnLabel} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <RawData />
            </CustomTabPanel>
          </>
        )}
      </Box>
    </>
  );
};

export default DatacollectionLastRunTabs;
